export const getRequestMethod = (requestInit: RequestInit): string =>
  requestInit.method ? requestInit.method.toUpperCase() : 'GET';
